// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    DiagnosisModelResponse,
    DiagnosisModels,
    DiagnosisSearchModelResponse,
    DiagnosisSearchRequestModel,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class DiagnosisV3Api extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @summary Gets the specified diagnosis identifier.
     * @param diagnosisId 
     */
    public async diagnosisGet (diagnosisId: number): Promise<AxiosResponse<DiagnosisModelResponse>> {
        const _url_ = '/diagnosis/v3/Diagnosis/{diagnosisId}'
            .replace('{' + 'diagnosisId' + '}', encodeURIComponent(String(diagnosisId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'diagnosisId' is not null or undefined
        if (diagnosisId === null || diagnosisId === undefined) {
            throw new Error('Required parameter diagnosisId was null or undefined when calling diagnosisGet.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<DiagnosisModelResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DiagnosisModelResponse");
        }
        return response;
    }
    /**
     * 
     * @summary Posts the specified request model.
     * @param diagnosisSearchRequestModel 
     */
    public async diagnosisSearch (diagnosisSearchRequestModel: DiagnosisSearchRequestModel): Promise<AxiosResponse<DiagnosisSearchModelResponse>> {
        const _url_ = '/diagnosis/v3/DiagnosisSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'diagnosisSearchRequestModel' is not null or undefined
        if (diagnosisSearchRequestModel === null || diagnosisSearchRequestModel === undefined) {
            throw new Error('Required parameter diagnosisSearchRequestModel was null or undefined when calling diagnosisSearch.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(diagnosisSearchRequestModel, "DiagnosisSearchRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<DiagnosisSearchModelResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DiagnosisSearchModelResponse");
        }
        return response;
    }
    /**
     * 
     * @summary Get Diagnosis List
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async programDiagnosisGetByProgramId (xProgramId?: number): Promise<AxiosResponse<DiagnosisModels>> {
        const _url_ = '/diagnosis/v3/ProgramDiagnosis';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "number");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<DiagnosisModels>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DiagnosisModels");
        }
        return response;
    }
    /**
     * 
     * @summary Get Diagnosis records associated with a Session
     * @param sessionId Session ID
     */
    public async sessionDiagnosisGet (sessionId: number): Promise<AxiosResponse<DiagnosisModels>> {
        const _url_ = '/diagnosis/v3/SessionDiagnosis/{sessionId}'
            .replace('{' + 'sessionId' + '}', encodeURIComponent(String(sessionId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'sessionId' is not null or undefined
        if (sessionId === null || sessionId === undefined) {
            throw new Error('Required parameter sessionId was null or undefined when calling sessionDiagnosisGet.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<DiagnosisModels>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DiagnosisModels");
        }
        return response;
    }
}
